import React from 'react';

const TABLE_CLASS_NAME = "w-full table-fixed border border-[#e0e1e3] border-collapse text-[12px]";
const TABLE_HEADER_CLASS_NAME = "w-1/4 p-[2px] bg-[#efefef] border border-[#e0e1e3] border-collapse text-start text-[#676a6c] text-[13px]";
const TABLE_CELL_CLASS_NAME = "p-1 border border-[#e0e1e3] border-collapse text-[#676a6c]";

const ResumeTable = ({title, columns, rows}) => {
    if (!rows.length) return null;

    return (
        <article className={"space-y-3"}>
            <h4 className={"mb-1"}>{title}</h4>

            <table className={TABLE_CLASS_NAME}>
                <thead>
                <tr>
                    {
                        columns.map(column => (
                            <th className={TABLE_HEADER_CLASS_NAME} key={column.field}>
                                {column.headerName}
                            </th>
                        ))
                    }
                </tr>
                </thead>
                <tbody>
                {
                    rows.map((row, index) => (
                        <tr key={row.id ?? index}>
                            {
                                columns.map(column => (
                                    <td
                                        className={`${index % 2 === 0 ? "bg-white" : "bg-[#efefef]"} ${TABLE_CELL_CLASS_NAME}`}
                                        key={column.field}
                                    >
                                        {column.render ? column.render(row) : row[column.field]}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </article>
    );
}

export default ResumeTable;
